import axios from 'axios';

const createLink = (idCompra, data) => axios.post(`/compras/${idCompra}/notas-fiscais`, data);

const getLinks = idCompra => axios.get(`/compras/${idCompra}/notas-fiscais`);

const removeLink = (idCompra, idNotaFiscal) => axios.delete(`/compras/${idCompra}/notas-fiscais/${idNotaFiscal}`);

const updateObservacao = (idCompra, idNotaFiscal, data) => axios.put(`/compras/${idCompra}/notas-fiscais/${idNotaFiscal}`, data);

export default {
  createLink,
  removeLink,
  getLinks,
  updateObservacao,
};
